// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.payment.PaymentTransactionResponse */
/* istanbul ignore next */
@GandalfModel
export class PaymentTransactionResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfConstantDecorator(constants.PaymentTransactionProcessor)
	@GandalfProperty({ designType: constants.PaymentTransactionProcessor })
	transactionProcessor!: constants.PaymentTransactionProcessor | null;

	@GandalfConstantDecorator(constants.PaymentTransactionType)
	@GandalfProperty({ designType: constants.PaymentTransactionType })
	transactionType!: constants.PaymentTransactionType | null;

}
